"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c6254a110{background:#fff;border-radius:var(--border-radius-def);padding:1.25rem 1.5625rem;position:relative}.c3639016d{display:block;margin-bottom:1rem}.c2a9e3daa{font-size:1rem;font-weight:500;line-height:1.125rem}.cd49b4cc7{font-size:.875rem;font-weight:400;line-height:1.25rem;margin-top:.3125rem;color:var(--color-flomni-gray-70)}.c143beeac{display:block}.c9706b991 .c2a9e3daa{padding-top:.3125rem}.c9706b991 .c3639016d{display:grid;grid-template-columns:1fr fit-content(100%);margin-top:-.3125rem;margin-right:-.3125rem;grid-gap:1rem;grid-gap:1rem;grid-gap:1rem;gap:1rem}");
var styles = {
  root: 'c6254a110',
  header: 'c3639016d',
  title: 'c2a9e3daa',
  description: 'cd49b4cc7',
  button: 'c143beeac',
  '--with-button': 'c9706b991'
};

var ChartContainer = function ChartContainer(props) {
  var children = props.children,
      title = props.title,
      description = props.description,
      classes = props.classes,
      button = props.button;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.with.button, !!button))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.header
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), !description ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.description
  }, description)), !button ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.button
  }, button)), /*#__PURE__*/_react.default.createElement("div", null, children));
};

exports.ChartContainer = ChartContainer;
ChartContainer.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  title: _propTypes.node.isRequired,
  description: _propTypes.node,
  button: _propTypes.node,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ChartContainer.defaultProps = {
  description: null,
  classes: {},
  button: null
};